module.exports = __webpack_public_path__ + "img/arrow_down_square.41fde59e.svg";